/** @jsx h */
import { h } from 'preact'
import Capsule from '../Capsule'
import ClaimVerifier from './ClaimVerifier'
import ProofPointStatus from '../ProofPointStatus'

const ClaimCard = props => {
  const {
    name,
    statement,
    footer,
    shadow,
    verifier,
    claimStatus
  } = props
  const shadowClass = shadow
  const verifierElement = verifier
    ? <ClaimVerifier verifier={verifier} claimStatus={claimStatus} showArrow />
    : null
  const footerClass = footer ? 'shown' : 'hidden'
  const statementElement = statement
    ? <div class='ClaimCard-statement'>{statement}</div>
    : null

  return (
    <div
      class={`ClaimCard ClaimCard--${shadowClass}`}
    >
      <div class='ClaimCard-header'>
        <div class='ClaimCard-title'>
          <Capsule label={name} small shadow={shadow} />
        </div>
      </div>
      <div class='ClaimCard-section'>
        {statementElement}
        {verifierElement}
        <ProofPointStatus status={claimStatus} />
      </div>
      <div class={`ClaimCard-footer ClaimCard-footer--${footerClass}`}>
        {footer}
      </div>
    </div>
  )
}

ClaimCard.defaultProps = {
  footer: null,
  ipfsHash: null,
  shadow: 'noShadow',
  verifier: null
}

export default ClaimCard
